import {getIdsSelector} from 'src/components/data-table-selection/services/data-table-selection-slice';
import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {SELECTION_KEY} from '../constants';

import {updateUsersEntitlementsStateSelector} from './update-users-entitlements-state.slice';


import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const updateUsersEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('updateUsersEntitlements');

export const updateUsersEntitlementsActions = updateUsersEntitlementsSlice.actions;
const updateUsersEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.accountPage.tabs.usersAndGroups.updateUsersEntitlements.cache;
export const updateUsersEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.accountPage.tabs.usersAndGroups.updateUsersEntitlements;
export const updateUsersEntitlementsResultSelector = getCachedTableResultSelector(
    updateUsersEntitlementsCacheSelector,
    updateUsersEntitlementsStateSelector,
);

export const entitlementsSelectionSelector = getIdsSelector(SELECTION_KEY);
